import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Direction, DirectionEnum} from '../enums/direction.enum';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {fromEvent} from 'rxjs';

@Injectable()
export class WindowEventsService {
    /**
     * Изменение направления скролла
     * @type {BehaviorSubject<any>}
     */
    public scrollDirectionChange$ = new BehaviorSubject<DirectionEnum>(null);

    private _visibleElementId$ = new BehaviorSubject<string>('');

    /**
     * Id элемента, в настоящий момент видимого на странице
     * @type {BehaviorSubject<string>}
     */
    public visibleElementId$ = this._visibleElementId$.pipe(
        distinctUntilChanged()
    );

    private _lastScrollPosition = 0;
    private _lastScrollDirection: number = null;


    constructor() {
        fromEvent(window, 'scroll').pipe(
            debounceTime(20)
        ).subscribe(() => {
            this.onWindowScroll();
            this.calculateVisibleElement();
        });
    }

    private onWindowScroll() {
        const pos = window.pageYOffset;

        const direction = pos > this._lastScrollPosition ? Direction.down : Direction.up;
        if (this._lastScrollDirection !== direction) {
            this.scrollDirectionChange$.next(direction);
            this._lastScrollDirection = direction;
        }

        this._lastScrollPosition = pos;
    }

    private calculateVisibleElement() {
        const elements = Array.from(document.querySelectorAll('fieldset[id]'));

        if (!elements.length) {
            return;
        }

        const values = elements.map(e => {
            const {top, bottom} = e.getBoundingClientRect();
            return {
                id: e.id,
                top,
                bottom,
            };
        });

        let visible;

        if (this._lastScrollDirection === Direction.up) {
            values.sort((a, b) => a.bottom >= b.bottom ? 1 : -1).some(v => {
                if (v.bottom >= 100) {
                    visible = v;
                    return true;
                }
            });
        } else {
            values.sort((a, b) => a.top >= b.top ? -1 : 1).some(v => {
                if (v.top <= (window.innerHeight - 40)) {
                    visible = v;
                    return true;
                }
            });
        }

        if (visible) {
            this._visibleElementId$.next(visible.id);
        }
    }
}
